import ColView from './col-view'

export default ColView
